import { IBraggResponseGameEvent } from "@spawn/backend-adapter-bragg";
import { consumer, inject } from "@spawn/core";
import { SpinActionExtendedBragg } from "@spawn/freegames";
import { PaylineType } from "@spawn/networking";
import { generateBraggNudgingOffsets } from "@spawn/nudge";
import {
    BraggSlotfaceRestoreService,
    ILevelDataBragg,
    ILevelsDataBragg,
    ensurePaddingMysteries,
    parseRevealBraggNetworkState,
    replaceRevealPositionsWithMysteries,
} from "@spawn/reveal";
import { BaseSymbolTypes, SymbolService, symbolTypeBraggIds } from "../../services/symbolService";
import { UncoverTierService } from "../../services/uncoverTierService";
import { IGameNetworkState } from "../networkState";
import { NrgBraggGameResult } from "../types/bragg";

@consumer
export class ExtendedSpinActionBragg extends SpinActionExtendedBragg {
	@inject protected readonly braggSlotfaceRestoreService!: BraggSlotfaceRestoreService;
	@inject protected readonly symbolService!: SymbolService;
	@inject protected readonly uncoverTierService!: UncoverTierService;

	protected parse(response: IBraggResponseGameEvent): IGameNetworkState {
		const result = super.parse(response) as IGameNetworkState;

		const { levelData } = this.extractLevelData(response.body as NrgBraggGameResult, result.slotGameBase.selectedBet);

		this.braggSlotfaceRestoreService.setLevelData(levelData);
		const uncoverTier = this.uncoverTierService.fromWinFactor(result.slotGameBase.winFactor);

		const feature: Partial<IGameNetworkState> = {};
		const reveals = levelData.reveals;

		if (reveals?.length) {
			replaceRevealPositionsWithMysteries(result.slotGameBase.reels, reveals, BaseSymbolTypes.Mystery);
			ensurePaddingMysteries(result.slotGameBase.reels, reveals, BaseSymbolTypes.Mystery);

			feature.reveal = parseRevealBraggNetworkState(reveals, symbolTypeBraggIds, uncoverTier);
			feature.nudging = generateBraggNudgingOffsets(reveals);
		} else {
			feature.reveal = {
				symbols: [],
			};
			feature.nudging = [];
		}

		this.symbolService.replaceSwingingMysteriesIfNotNeeded(result.slotGameBase.reels);

		return {
			...result,
			slotGameBase: {
				...result.slotGameBase,
				paylines: result.slotGameBase.paylines.filter(({ type }) => type !== PaylineType.Scatter),
			},
			...feature,
		};
	}

	private extractLevelData(
		response: NrgBraggGameResult,
		bet: number
	): { levelsData: ILevelsDataBragg; levelData: ILevelDataBragg } {
		return {
			levelsData: response.data.SLOT.levelData,
			levelData: { ...response.data.SLOT.levelData[String(bet)], level: String(bet) },
		};
	}
}
